<template>
    <div v-if="hasCrossprice || currentShopSale || availabilityStr != ''" class="special-tags">
        <span class="tag percentage" v-if="hasCrossprice" v-html="percentage"></span>
        <span class="tag percentage" v-else-if="currentShopSale" v-html="currentShopSaleText"></span>
        <span class="tag delivery" v-if="availabilityStr != ''" v-html="availabilityStr"></span>
    </div>
</template>

<script>
import { isDefined } from "../../helper/utils";

export default {

    name: "item-store-special",

    props: {
        recommendedRetailPrice: {
            type: Object
        },
        variationRetailPrice: {
            type: Object
        },
        decimalCount: {
            type: Number,
            default: 2
        },
        currentShopSale: {
            type: Boolean,
            default: false
        },
        availability: {
            type: Number,
            default: 5
        }
    },
    computed:
    {
        hasCrossprice() {
            return (isDefined(this.variationRetailPrice) && isDefined(this.recommendedRetailPrice) && isDefined(this.variationRetailPrice.unitPrice)) 
            && this.recommendedRetailPrice.unitPrice.value > this.variationRetailPrice.unitPrice.value;
        },

        percentage() {
            if (this.hasCrossprice) {
                const rrpPrice = this.recommendedRetailPrice.unitPrice.value;
                const beforePrice = this.variationRetailPrice.unitPrice.value;
                return "-" + ((rrpPrice - beforePrice) / rrpPrice * 100).toFixed(0).replace(".", App.decimalSeparator) + "%";
            }
            return "";
        },

        availabilityStr() {
            if(this.availability == 1)
                return "Sofort lieferbar";
            return "";
        } ,

        currentShopSaleText()
        {
            return App.nwConfig.shopSale.badgeText ?? "";
        }
    }
}
</script>
